/*
 * @Author: liyifan 
 * @Date: 2024-06-26 10:35:56 
 * @Last Modified by: liyifan
 * @Last Modified time: 2024-08-30 15:00:01
 * @description 首页-场景教育
 */
import { calcTop, isMobile} from '@utils/index.js'
export class SceneEducation {
    constructor() {
        this.init()
    }
    init() {
        if(!isMobile()) {
            const headerTop = calcTop()
            const afterSalesHeight =  $('.header-after-sales').height() || 0
            $('.scene-education .title').css({
                top: `${headerTop + afterSalesHeight + 80}px`
            })
            
            const flag = $('.index-scene-education').data('new-header')
            const el = flag ?  $(".locale-switcher") : $(".site-header")

            const config = {attributes: true}
            // 当观察到变动时执行的回调函数
            const callback = function (mutationsList, observer) {
                // Use traditional 'for loops' for IE 11
                for (let mutation of mutationsList) {
                    if (mutation.type === "attributes" && mutation.attributeName === 'class') {
                        const headerTop = calcTop()
                        const afterSalesHeight =  $('.header-after-sales').height() || 0
                        $('.scene-education .title').css({
                            top: `${headerTop + afterSalesHeight + 80}px`
                        })
                    }
                }
            };
            // 创建一个观察器实例并传入回调函数
            const observer = new MutationObserver(callback);
            if (el[0]) {
                observer.observe(el[0], config);
            }
        }
    }
}